module.exports = __webpack_public_path__ + "static/media/orange_bogen.53050ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/orange_bogen.png
// module id = 745
// module chunks = 0